export const validationMessages = {
    common_required: (field: string): string => `${field} is required.`,
    common_minLength: (field: string, length: number): string => `${field} must be at least ${length} characters.`,
    common_maxLength: (field: string, length: number): string => `${field} cannot exceed ${length} characters.`,
    common_email: (field: string): string => `${field} email must be in a valid format (e.g., user@example.com).`,
    common_phone: "Please enter a valid mobile number",

    common_toggletitle: (action: string, field: string): string =>
        `${action} ${field}`,
    common_toggleConfirm: (action: string, field: string): string =>
        `Are you sure you want to ${action} this ${field === 'Note' ? ' note/comment' : field}?`,

    commen_invalidCategoryString: (field: string): string => `${field} must only contain alphanumeric characters.`,
    common_invalidString: (field: string): string => `${field} must only contain alphabetic characters.`,
    common_invalidStringAplamumeric: (field: string): string => `${field} must only contain alphanumeric characters.`,
    common_invalidStringAlphanumericWithHyphenUnderscoreBlankSpace: (field: string): string => `${field} can only contain letters, numbers, spaces, hyphens, and underscores.`,
    common_RecordNotFound: (text: string): string => `No ${text} found matching the search criteria.`,
    common_invalidSpecialChar: (field: string): string => `${field} can't contain special characters.`,
    common_characterLimit: (field: string, limit: number): string => `${field} can't exceed ${limit} characters.`,
    common_invalidNumber: (field: string): string => `${field} must contain only number.`,
    common_invalidDate: (field: string): string => `${field} must be in a valid format.`,
    common_negativeNumber: (field: string): string => `${field} must be a positive number.`,
    common_invalidStringSpecialCharacters: (field: string): string => `${field} must only contain alphanumeric characters.`,
    commin_maxFileSize: (field: string, size: number): string => `${field} file size must be less than ${size} MB.`,
    common_duplicateRecord: (field: string): string => `${field} already exist.`,
    SubFeeStage_Confirm :(filed :string): string => `Are you sure you want to change the status to ${filed}?`,
    common_GreaterThanZeroNumber: (field: string): string => `A value of 0 is not allowed.`,

    common_CopyTitle: 'Make a Copy',
    common_CopyMessage: (field: string) => `Are you sure you want to make a copy of this ${field} ?`,
    common_CopySucess: (field: string) => `${field} copied successfully`,
    common_Error: 'Error occur! Please try again',

    user_searchText: "Search for a user by name, email",


    client_searchText: "Search for a client by client name and number",
    client_InsertResponse_Text: "Client created successfully",

    clientContact_searchText: "Search for a client-contact by client name, email and office",

    uploadedDocuments_searchText: "Search for an uploaded document",
    notesComments_searchText: "Search for notes/comments",
    notesComments_required: "Please enter note/comment",

    framework_InsertResponse_Text: "Framework added successfully",
    framework_searchText: "Search for a framework by framework name and associated client",
    framework_dialog_Warning: (projectnames: string): string => {
        const projectsList = projectnames
            .split(',')
            .map(project => ` ${project.trim()}`)
            .join('\n');

        return `Framework is used in the following projects:\n${projectsList}`;
    },

    framework_endDate: "End date must be greater than start date",

    feeStage_searchText: "Search for a fee stage within a framework",

    category_searchText: "Search for a Client Category by Name, Description",
    region_searchText: "Search for a Client Region by Name, Description",
    feeStageArea_searchText: "Search for a Fee Stage Area by Name, Description",
    tags_searchText: "Search for a Tag by Name, Description",
    personnel_searchText: "Search for a Personnel by Name, Email",

    project_searchText: "Search for a project by Project Number, Project Name, and Client Name",
    parties_searchText: "Search for parties involved by Name and Email",

    project_AFP_IntervalChange: (type: string): string => {
        switch (type) {
            case 'submission':
                return 'Are you sure you want to change the interval date? This will change all future dates.';
            case 'certification':
                return 'Do you want to update certificate and payment dates from today onward?';
            case 'expected':
                return 'Do you want to update expected payment dates from today onward?';
            default:
                return '';
        }
    },

    invalid_proposal_Number: "Proposal number format is not correct. Example: (ProjectNumber/P01 Rev A).",
    proposal_searchText: "Search for a Proposal by Name, Number",
    proposal_InsertResponse_Text: "Proposal added successfully",

    proposal_InstructedRefernceExistText: "Instruction reference already exist.",
    proposal_feestage_serachText: "Search for a fee stage in this proposal",
    proposal_General_proposalType: "Please ensure the quantity in the fee stages before making it ready to review.",
    proposal_InstructedValueCheck: (fieldName: string, maxValue: string, minValue: any): string => `The ${fieldName} must be greater than ${minValue} and less than or equal to ${maxValue}.`,
    proposal_InstructionValueCheck: "The Instruction Value must equal the sum of the selected Proposal Values.",
    proposal_InstructedFeeStageText: "Please select atleast one Instructed fee stage",
    proposal_InstructedValueText: "Please enter an instructed value for each fee stage; no selected fee stage should have an instructed value of 0.",
    //invoice
    Invoice_ProjectInvoiceTypesNotSelected:"Please Select the Invoice Types for all projects",
};